/**
 * Shared by the live map popup (src/web/client/main.ts) and the "Major Outage"
 * card (src/web/pages.ts, user decision 2026-10-10: "reuse the worsening,
 * improving bar") -- moved here from main.ts so both places classify a trend the
 * same way instead of two copies of the same thresholds silently drifting apart.
 * Pure, no I/O -- same reasoning as every other domain file.
 */

export type Trend = 'worse' | 'better' | 'steady';

/**
 * A 10% dead-zone either side of the first-recorded figure -- otherwise a single
 * customer coming back online would flip the badge on effectively every poll. Below
 * a zero baseline a percentage is meaningless, so a small absolute floor (5) stands
 * in instead -- both thresholds are a judgement call, not derived from anything, and
 * worth revisiting if they feel wrong in practice.
 */
const TREND_DEAD_ZONE = 0.1;
const ZERO_BASELINE_FLOOR = 5;

export function classifyTrend(current: number, first: number): Trend {
  if (first === 0) return current > ZERO_BASELINE_FLOOR ? 'worse' : 'steady';
  const change = (current - first) / first;
  if (change > TREND_DEAD_ZONE) return 'worse';
  if (change < -TREND_DEAD_ZONE) return 'better';
  return 'steady';
}

export const TREND_ARROW: Record<Trend, string> = { worse: '↑', better: '↓', steady: '→' };
export const TREND_WORD: Record<Trend, string> = { worse: 'worsening', better: 'improving', steady: 'steady' };
